import {removeTagFromOrders} from '../../../data/orderTags.js'
import {hasOrderManageTagOnOrderPermissionSelector} from '../../../data/me.js'
import AssignedTags from '../../../common/components/List/AssignedTags/index.js'
import {useSelector} from '../../../store.js'

export default function OrderTags({order}) {
  const hasOrderManageTagOnOrderPermission = useSelector(
    hasOrderManageTagOnOrderPermissionSelector,
  )

  return (
    <AssignedTags
      tags={order.tags}
      hasManageTagOnOrderPermission={hasOrderManageTagOnOrderPermission}
      onRemove={(tag) => removeTagFromOrders(tag.id, [order.order_number])}
    />
  )
}
